const commentsData = [
  {
    avatar: '吃瓜不嫌事大',
    time: '2小时前',
    content: '黑料网真的太顶了！每天打开都能看到最新最热的内容，每日大赛那个板块简直是我的快乐源泉，推荐给了身边所有朋友，大家都说好！',
    likes: 2386,
    badge: '铁粉',
  },
  {
    avatar: '深夜追剧人',
    time: '5小时前',
    content: '用了黑料不打烊之后就把其他视频APP都卸载了，这里不仅完全免费，更新速度还贼快。昨天那个明星八卦刚上热搜，这边就已经有完整梳理视频了，太牛了！',
    likes: 1852,
    badge: '活跃用户',
  },
  {
    avatar: '娱乐圈观察员',
    time: '8小时前',
    content: '作为一个老吃瓜人，黑料在线真的是我用过最好用的内容平台。12个话题板块覆盖全面，视频质量也高，特别是那个热度榜单，每天必刷，强烈安利！',
    likes: 1421,
    badge: '资深用户',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">网友热评</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600">
            来看看大家对黑料平台的真实评价
          </p>
        </div>

        <div className="space-y-4">
          {commentsData.map((comment, idx) => (
            <div
              key={idx}
              className="bg-background-100 border border-background-300/30 rounded-xl p-5 md:p-6"
            >
              <div className="flex items-start gap-4">
                {/* Avatar */}
                <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary-500/10 flex items-center justify-center">
                  <span className="text-sm font-bold text-primary-400">
                    {comment.avatar.charAt(0)}
                  </span>
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-sm font-semibold text-foreground-900">{comment.avatar}</span>
                    <span className="text-xs bg-accent-500/10 text-accent-400 px-2 py-0.5 rounded-md font-medium whitespace-nowrap">
                      {comment.badge}
                    </span>
                    <span className="text-xs text-foreground-500">{comment.time}</span>
                  </div>

                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                    {comment.content}
                  </p>

                  <div className="mt-3 flex items-center gap-1 text-xs text-foreground-500">
                    <i className="ri-thumb-up-line"></i>
                    <span>{comment.likes.toLocaleString()}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}